import { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import TaskStatusLabel from '../TaskStatusLabel';

import { addToast } from '~features/toast/ducks';

import { fetchOrder } from '~services/api.helpers';

import { Modal, ModalWrapper, Spinner, OrderWindow } from '~ui-kit';
import { blue } from '~theme';

const OrderModal = ({ orderId, onHide, show, ...props }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const updateOrder = async () => {
      setLoading(true);
      try {
        const res = await fetchOrder(orderId);
        setOrder(res);
      } catch (e) {
        console.error('Error in fetching order for OrderModal', e);
        setLoading(false);
        dispatch(
          addToast({
            message: 'Tilauksen hakeminen epäonnistui',
            type: 'ERROR',
          })
        );
      }
      setLoading(false);
    };

    if (orderId && show && order === null) {
      updateOrder();
    }
  }, [orderId, show]);

  const title = `Tilaus: ${orderId}${
    order ? ` ${order.categoryName || 'Tuntematon'}` : ''
  }`;

  const navigate = useNavigate();

  return (
    <Modal show={show} onHide={onHide}>
      <ModalWrapper
        {...props}
        close={onHide}
        title={title}
        backText="Sulje"
        backOnClick={onHide}
        confirmText="Siirry tilauksen sivulle"
        confirmOnClick={() => navigate(`/tilauslista?ordernumber=${orderId}`)}
      >
        <Content>
          {loading ? (
            <Spinner />
          ) : (
            <Content>
              {order && (
                <Order>
                  <Header>
                    <TaskStatusLabel status={order.status} />
                    <Timestamp>
                      {moment(order.initiationTime).format('DD.MM.YYYY')}
                    </Timestamp>
                  </Header>

                  <OrderWindow height="300px" order={order} />
                </Order>
              )}
            </Content>
          )}
        </Content>
      </ModalWrapper>
    </Modal>
  );
};

const Content = styled.div`
  margin-bottom: 24px;
`;

const Order = styled.div``;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  color: ${blue};
  font-weight: 600;
`;

const Timestamp = styled.div`
  margin-left: 12px;
`;

export default OrderModal;
